module.exports = __webpack_public_path__ + "static/media/api-serverless.5608ec2d.jpeg";